"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "addAlpha", {
  enumerable: true,
  get: function () {
    return _addAlpha.default;
  }
});
Object.defineProperty(exports, "fit", {
  enumerable: true,
  get: function () {
    return _fit.default;
  }
});
Object.defineProperty(exports, "hasNoData", {
  enumerable: true,
  get: function () {
    return _hasNoData.default;
  }
});
Object.defineProperty(exports, "hideRgba", {
  enumerable: true,
  get: function () {
    return _hideRgba.default;
  }
});
Object.defineProperty(exports, "isHidden", {
  enumerable: true,
  get: function () {
    return _isHidden.default;
  }
});
Object.defineProperty(exports, "isNoData", {
  enumerable: true,
  get: function () {
    return _isNoData.default;
  }
});
Object.defineProperty(exports, "makeNoDataRgb", {
  enumerable: true,
  get: function () {
    return _makeNoDataRgb.default;
  }
});
Object.defineProperty(exports, "makeNoDataRgba", {
  enumerable: true,
  get: function () {
    return _makeNoDataRgba.default;
  }
});
Object.defineProperty(exports, "popAlpha", {
  enumerable: true,
  get: function () {
    return _popAlpha.default;
  }
});
Object.defineProperty(exports, "range", {
  enumerable: true,
  get: function () {
    return _range.default;
  }
});
Object.defineProperty(exports, "rawToRgb", {
  enumerable: true,
  get: function () {
    return _rawToRgb.default;
  }
});
Object.defineProperty(exports, "rawToRgba", {
  enumerable: true,
  get: function () {
    return _rawToRgba.default;
  }
});
Object.defineProperty(exports, "rgbToRgba", {
  enumerable: true,
  get: function () {
    return _rgbToRgba.default;
  }
});
Object.defineProperty(exports, "rgbToStr", {
  enumerable: true,
  get: function () {
    return _rgbToStr.default;
  }
});
Object.defineProperty(exports, "rgbaToRgb", {
  enumerable: true,
  get: function () {
    return _rgbaToRgb.default;
  }
});
Object.defineProperty(exports, "setHidden", {
  enumerable: true,
  get: function () {
    return _setHidden.default;
  }
});
Object.defineProperty(exports, "setVisible", {
  enumerable: true,
  get: function () {
    return _setVisible.default;
  }
});
Object.defineProperty(exports, "showRgba", {
  enumerable: true,
  get: function () {
    return _showRgba.default;
  }
});
Object.defineProperty(exports, "sliceAlpha", {
  enumerable: true,
  get: function () {
    return _sliceAlpha.default;
  }
});
var _addAlpha = _interopRequireDefault(require("./add-alpha"));
var _fit = _interopRequireDefault(require("./fit"));
var _hasNoData = _interopRequireDefault(require("./has-no-data"));
var _hideRgba = _interopRequireDefault(require("./hide-rgba"));
var _isHidden = _interopRequireDefault(require("./is-hidden"));
var _isNoData = _interopRequireDefault(require("./is-no-data"));
var _makeNoDataRgb = _interopRequireDefault(require("./make-no-data-rgb"));
var _makeNoDataRgba = _interopRequireDefault(require("./make-no-data-rgba"));
var _popAlpha = _interopRequireDefault(require("./pop-alpha"));
var _range = _interopRequireDefault(require("./range"));
var _rawToRgb = _interopRequireDefault(require("./raw-to-rgb"));
var _rawToRgba = _interopRequireDefault(require("./raw-to-rgba"));
var _rgbToRgba = _interopRequireDefault(require("./rgb-to-rgba"));
var _rgbToStr = _interopRequireDefault(require("./rgb-to-str"));
var _rgbaToRgb = _interopRequireDefault(require("./rgba-to-rgb"));
var _setHidden = _interopRequireDefault(require("./set-hidden"));
var _setVisible = _interopRequireDefault(require("./set-visible"));
var _showRgba = _interopRequireDefault(require("./show-rgba"));
var _sliceAlpha = _interopRequireDefault(require("./slice-alpha"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }